export enum ModalSizeTypes {
  Small = 'sm', // default
  Medium = 'm',
  Large = 'lg',
  ExtraLarge = 'xl',
  ExtraExtraLarge = 'xxl'
}
